export class RecodeGameAutoplayHandlerModuleEvents {
	public static readonly RECODE_AUTOPLAY_SHOW_POPUP: string = 'RecodeGameAutoplayModuleEvents::RECODE_AUTOPLAY_SHOW_POPUP';
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/autoplay/recode/RecodeGameAutoplayHandlerModuleEvents.ts